define('models/Podio.Models.LinkedAccount',['require','underscore','lib/backbone/Backbone.PodioModel'],function(require) {

  var _ = require('underscore');
  var PodioModel = require('lib/backbone/Backbone.PodioModel');

  return PodioModel.extend({
    permissionOptions: function() {
      var specialSettings = {
        'google': {
          'preserve': true,
          'grant': true
        },
        'boxnet': {
          'preserve': true,
          'grant': true
        }
      };
      var defaultSettings = {
        'preserve': false,
        'grant': true
      };

      return specialSettings[this.get('provider')] || defaultSettings;
    },
  });
});

